import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import renderEnvComponent from 'data/common/renderEnvComponent';
import PropTypes from 'prop-types';
import SDM17DEC from './SDM17DEC';
import SDM17SPT from './SDM17SPT';
import SDM19DE2 from './SDM19DE2';
import SDM19DEE from './SDM19DEE';
import SDM18HCL from './SDM18HCL';
import SDM17SPG from './SDM17SPG';
import SDM19SG2 from './SDM19SG2';
import SDM18HCN from './SDM18HCN';
import SDM18SP2 from './SDM18SP2';
import SDM18MVR from './SDM18MVR';
import SDM22MVR from './SDM22MVR';
import SDM19STM from './SDM19STM';
import SDM19DAF from './SDM19DAF';
import SDM19DRS from './SDM19DRS';
import SDM19PIR from './SDM19PIR';
import SDM19SIR from './SDM19SIR';
import SDM19WTS from './SDM19WTS';
import SDM19TMT from './SDM19TMT';
import SDM20LHT from './SDM20LHT';
import SDM22LHT from './SDM22LHT';
import SDM22MMB from './SDM22MMB';
import SDM22MFP from './SDM22MFP';
import SDM19INL from './SDM19INL';
import SDM23SMP from './SDM23SMP';
import SDM22MTI from './SDM22MTI';

import BasicForm from './BasicForm';

class FHEProductDetail extends PureComponent {
    static propTypes = {
        moduleType: PropTypes.string.isRequired,
    };

    render() {
        const { moduleType } = this.props;

        const detailContentByType = {
            SDM17DEC: () => <SDM17DEC {...this.props} />,
            SDM17SPT: () => <SDM17SPT {...this.props} />,
            SDM19DE2: () => <SDM19DE2 {...this.props} />,
            SDM19DEE: () => <SDM19DEE {...this.props} />,
            SDM18MVR: () => <SDM18MVR {...this.props} />,
            SDM22MVR: () => <SDM22MVR {...this.props} />,
            SDM18HCL: () => <SDM18HCL {...this.props} />,
            SDM17SPG: () => <SDM17SPG {...this.props} />,
            SDM19SG2: () => <SDM19SG2 {...this.props} />,
            SDM18HCN: () => <SDM18HCN {...this.props} />,
            SDM18SP2: () => <SDM18SP2 {...this.props} />,
            SDM19STM: () => <SDM19STM {...this.props} />,
            SDM19DAF: () => <SDM19DAF {...this.props} />,
            SDM19DRS: () => <SDM19DRS {...this.props} />,
            SDM19PIR: () => <SDM19PIR {...this.props} />,
            SDM19SIR: () => <SDM19SIR {...this.props} />,
            SDM19WTS: () => <SDM19WTS {...this.props} />,
            SDM19TMT: () => <SDM19TMT {...this.props} />,
            SDM20LHT: () => <SDM20LHT {...this.props} />,
            SDM22LHT: () => <SDM22LHT {...this.props} />,
            SDM22MMB: () => <SDM22MMB {...this.props} />,
            SDM22MFP: () => <SDM22MFP {...this.props} />,
            SDM22MTI: () => <SDM22MTI {...this.props} />,
            SDM23SMP: () => <SDM23SMP {...this.props} />,
            SDM19INL: () => <SDM19INL {...this.props} />,

            default: () => null,
        };
        return <BasicForm {...this.props}>{(detailContentByType[moduleType] || detailContentByType['default'])()}</BasicForm>;
    }
}
export default withRouter(renderEnvComponent('scenes/Products/components/Product/Fhe/index', FHEProductDetail));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/index.js